<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p3
        Folic Acid Deficiency
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
    <div class="v-mthfr-p3" title="mthfr-p3">
      <img-card class="card">
        <div slot="title">{{$t('Mthfr.P3_Title')}}</div>
        <p>{{$t('Mthfr.P3_Content')}}</p>
        <div class="tips-wrapper">
          <div class="tips-title">{{$t('Mthfr.p3_2_Title')}}</div>
          <ul class="tips-ul">
            <li>
              <img src="../../../assets/images/mthfr/p3-1.png">
              <div class="info">
                <div class="tip-title">{{$t('Mthfr.P3_2_1_1')}}</div>
                <div class="tip-value">{{$t('Mthfr.P3_2_1_2')}}</div>
              </div>
            </li>
            <li>
              <img src="../../../assets/images/mthfr/p3-2.png">
              <div class="info">
                <div class="tip-title">{{$t('Mthfr.P3_2_2_1')}}</div>
                <div class="tip-value">{{$t('Mthfr.P3_2_2_2')}}</div>
              </div>
            </li>
          </ul>
        </div>
      </img-card>
    </div>
</template>

<script>
    import Card from "../../../components/card";
    import ImgCard from "../img-card";
    export default {
        name: "mthfr-p3",
      components: {ImgCard, Card}
    }
</script>

<style  lang="scss">
    .v-mthfr-p3 {
      background-color: rgba(251, 207, 192, 0.2);
      .tips-wrapper {
        margin-top: 1.72vw;

        .tips-title {
          display: inline-block;
          font-size: .8vw;
          background: #c03239;
          padding: .5vw .8vw;
          color: #fff;
          border-radius: 1vw;
          margin-bottom: 12px;
        }

        .tips-ul {
          display: flex;
          margin: 0;
          padding: 0 0 0 1vw;

          li {
            display: flex;
            align-items: center;
            margin-right: 2vw;

            img {
              width: 2.5vw;
            }

            .info {
              margin-left: .5vw;
              .tip-title {
                font-size: 1vw;
                color: #e89db6;
              }

              .tip-value {
                font-size: 1vw;
                padding-left: 18px;
                position: relative;
                &:before {
                  content: '●';
                  display: block;
                  position: absolute;
                  left: 0;
                  top: 3px;
                  padding-right: .5vw;
                  font-size: 12px;
                  color: #e89db6;
                }
              }
            }
          }
        }
      }
    }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p3.vue